<script setup lang="ts">
import type { Person } from '@pkg/ui/types/person';
import BaseImage from '@pkg/ui/components/base/BaseImage.vue';
import { BaseTile } from '../Tiles/BaseTile';

interface Props {
  person: Person;
}

defineProps<Props>();
</script>

<template>
  <BaseTile :title="person.name || ''" variant="imageLeft" :as-link="false">
    <template #image>
      <BaseImage v-if="person.image" :image="person.image" auto="format" :width="126" :height="126" />
    </template>
    <template #description>
      <p class="c-people-tile__job-title">
        {{ person.jobTitle }}
      </p>
    </template>
  </BaseTile>
</template>

<style scoped>
.c-people-tile__job-title {
  font-weight: theme('fontWeight.bold');
  color: var(--theme-tertiary-text-color);
}

:deep(.c-tile__content) {

  @screen tablet {
    padding: 0.5rem 1rem;
  }

  @screen desk {
    padding: 0.5rem 1.5rem;
  }
}
</style>
